module.exports = __webpack_public_path__ + "img/hohlschnitt_blau_candy.680499ac.jpg";